'use client';

import {FC, PropsWithChildren, useLayoutEffect, useRef} from 'react';
import ReactDOM from 'react-dom';
import {useHeaderState} from './useHeaderState';

interface Props {
	position?: 'left' | 'right' | 'center' | 'banner';
}

// TODO: remove useHeaderState!!!!!!!!
export const HeaderPortal: FC<PropsWithChildren<Props>> = ({position = 'right', children}) => {
	const ref = useRef<HTMLDivElement>(document.createElement('div'));
	const {state: mounted} = useHeaderState();

	useLayoutEffect(() => {
		ref.current.className = position === 'banner' ? 'flex w-full flex-1 min-w-0 justify-center' : '';

		const root = document.querySelector(`#header-slot-${position}`);

		if (!root) {
			console.error('header portal: failed to find root element');

			return;
		}

		root.append(ref.current);

		return () => {
			root.removeChild(ref.current);
		};
	}, [position, mounted]);

	if (!ref.current) return null;

	return ReactDOM.createPortal(children, ref.current);
};
